import * as VerticalTabs from "./vertical-tabs";
export { VerticalTabs };
